export {
  axisTop,
  axisRight,
  axisBottom,
  axisLeft
} from "./src/axis";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-axis/index.js
// module id = 416
// module chunks = 0